import React, { useEffect } from "react";
import "../styles/Home.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message ="Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (

    <div className="homepage">
      {/* Header Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <h1>
            Welcome to <span className="highlight">Reddy Anna Book</span>
          </h1>
          {/* <p>India's No.1 sports ID provider since 2010</p> */}
          <p>India's most experienced fantasy cricket platform, trusted since 2010</p>
          {/* <p>
            Do you want to open your
            cricket ID online but can’t find a trustworthy betting platform?
            Here's Reddy Anna Book for you.  This is India's most famous and trusted cricket demo ID platform. Reddy Anna Book is India's largest exchange platform, offering fantastic online sports betting with a 24-hour withdrawal service.
          </p> */}
          <p>
          Step into the thrilling world of fantasy cricket, where every match becomes your strategic playground! From mastering team selection to analyzing player performance, discover a wealth of expert resources tailored for both newcomers and veterans alike. Transform your cricket knowledge into skillful decisions that make each game more rewarding than the last.
            </p>
          <div className="home-btn">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              Contact Us @ 7777857777
            </a><br /><br />
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              WhatsApp Us @ 7777077773
            </a>

          </div>
        </div>
        <div className="hero-image">
          <img src="home.webp" alt="Sports Equipment" />
        </div>
      </section>

      {/* Customer Support Section */}
      <section className="customer-support" id="support">
        <h3>Reddy Anna <span className="highlight">Customer Support</span></h3>
        <p>
          Get in touch with REDDY ANNA for any Queries, Emergencies, <br />Feedback or Complaints. We are here to help you 24/7 with our <br />online services.
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>

      </section>

    </div>
  );
};

export default Home;
